import { useEffect, useState } from "react";
import { SelectComponents, SelectDropDown } from "~/components/ui";
import { cn } from "~/lib/utils.ts";

import { ErrorProps, FormError } from ".";

// import { formValuesToUppercase } from "~/lib/utils";
interface Option {
  label: string;
  value: string;
}
type Props = {
  autoFocus?: boolean;
  onModal?: boolean;
  label: string;
  required?: boolean;
  errors?: ErrorProps;
  options: Option[];
  defaultValue?: Option;
  placeholder?: string;
  components?: Partial<SelectComponents>;
  value?: Option;
  isLoading?: boolean;
  isDisabled?: boolean;
} & (
  | {
      isMulti: false;
      onChange: (option: Option) => void;
    }
  | {
      isMulti: true;
      onChange: (option: Option[]) => void;
    }
);
export default function FormSelectInput({
  label,
  required,
  errors,
  options,
  defaultValue,
  onChange,
  placeholder,
  isMulti,
  components,
  value: propValue,
  isLoading,
  isDisabled,
  onModal,
}: Props) {
  const [value, setValue] = useState<Option | undefined>(
    propValue || defaultValue,
  );
  useEffect(() => {
    if (propValue !== undefined) {
      setValue(propValue as Option | undefined);
    } else {
      setValue(defaultValue);
    }
  }, [setValue, defaultValue, propValue]);

  return (
    <div>
      <label className="space-y-1">
        <div
          className={cn("font-Medium text-sm", {
            "text-danger-500": errors?.error,
          })}
        >
          {label} {required && <span className="text-danger-400">*</span>}
        </div>
        <SelectDropDown
          onModal={onModal}
          isDisabled={isDisabled}
          isLoading={isLoading}
          isMulti={isMulti}
          classNames={{
            container: () =>
              cn(
                "text-sm border-neutral-300 rounded-2xl focus-within:border-secondary-500 focus-within:ring-1 focus-within:ring-secondary-500",
                {
                  "border-danger-500": errors && errors.error,
                },
              ),
          }}
          className="rounded-2xl border bg-white shadow-sm focus-within:border-secondary-500 focus-within:ring-1 focus-within:ring-secondary-500"
          options={options?.map((opt) => opt)}
          onChange={(option) => {
            isMulti ? onChange(option as Option[]) : onChange(option as Option);
          }}
          placeholder={placeholder}
          components={components}
          value={value}
        />
        <FormError error={errors?.error} message={errors?.message} />
      </label>
    </div>
  );
}
